// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2uO1F","col":"Table_col__1htzZ","fulfillmentStatus":"Table_fulfillmentStatus__1yNbY","emailCol":"Table_emailCol__5p9I5"};